/* eslint-disable max-len */
export default {
  ACTIONS: {
    BACK: 'Volver',
    BACK_TO_SEARCH: 'Volver a la búsqueda',
    CANCEL: 'Cancelar',
    CANCEL_DELIVERY_REQUEST: 'Cancelar solicitud',
    CHANGE_DAY: 'Cambiar el día',
    CHANGE_LOCATION: 'Cambiar la ubicación',
    CLICK_TO_EXPAND: 'Haz clic o desliza para expandir',
    COLLECT_PIN: 'Código de recogida',
    CONFIRM: 'Confirmar',
    CURRENT_LOCATION: 'Usar ubicación actual',
    EDIT_PIN: 'Editar chincheta de ubicación',
    HELP_US_IMPROVE: 'Ayúdanos a mejorar',
    LEAVE: 'salir',
    NEW_SEARCH: 'Nueva búsqueda',
    PICK_UP_PIN: 'Código de recogida',
    PICK_UP_POINT: 'Punto de recogida',
    SAME_LOCATION: 'Misma ubicación',
    SCAN_QR_CODE: 'Escanear el código QR',
    SEARCH: 'Buscar',
    SIGN_IN: 'Iniciar sesión para cambiar la solicitud de orden',
    SIGN_IN_FOR_EVALUATION: 'Iniciar sesión para ayudarnos a mejorar',
    SWIPE_DOWN: 'Deslizar hacia abajo para ocultar los detalles',
    SWIPE_UP: 'Deslizar hacia arriba para ver los detalles'
  },
  ERRORS: {
    SERVICE_POINT_DOES_NOT_ACCEPT_COLLECTS:
      '¡El punto de servicio no dispone de servicio de recogida!',
    SERVICE_POINT_DOES_NOT_ACCEPT_ICE:
      '¡El punto de servicio no acepta pedidos con productos congelados!',
    SERVICE_POINT_DOES_NOT_HAVE_CAPACITY:
      '¡El punto de servicio ha alcanzado la capacidad máxima de pedidos!',
    SOMETHING_WENT_WRONG:
      'Se ha producido un error. Inténtalo de nuevo más tarde.',
    ZIP_CODE_WRONG_FORMAT: 'formato de código postal no válido'
  },
  LABELS: {
    CURRENT: 'de',
    DELETE_MESSAGE: 'Eliminar mensaje',
    ERROR: 'Error',
    NEW: 'para',
    NEW_ADDRESS: 'Nueva dirección',
    OR: 'O',
    ORIGINAL_ADDRESS: 'Dirección original',
    PICK_UP_POINT: 'Punto de recogida',
    REQUIRES_CONFIRMATION: 'Cambio pendiente de confirmación',
    SAME_DAY_COLLECT: 'Recogida en el mismo día',
    SAME_DAY_DELIVERY: 'Entrega en el mismo día',
    SCHEDULE: 'Hora',
    SEARCH_LOCATION: 'Buscar dirección'
  },
  MESSAGES: {
    ADICIONAL_ADDRESS: 'Complemento de dirección',
    ADJUST_PIN: 'Ajustar chincheta de ubicación',
    BUILDING_DOOR_NUMBER: 'Número',
    CALL_US: 'llámanos',
    CHANGE_ADDRESS: 'Cambiar dirección',
    CHANGE_ADDRESS_AUTOMATIC_COLLECT:
      'Se ha cambiado la dirección de recogida.',
    CHANGE_ADDRESS_AUTOMATIC_DELIVERY:
      'Se ha cambiado la dirección de entrega.',
    CHANGE_ADDRESS_TO_PICK_UP:
      'Seleccionar punto de recogida como dirección de envío',
    CHANGE_COLLECT: 'Cambiar recogida',
    CHANGE_DATE_AND_ADDRESS_AUTOMATIC_COLLECT:
      'Se ha cambiado la fecha y la dirección de recogida.',
    CHANGE_DATE_AND_ADDRESS_AUTOMATIC_DELIVERY:
      'Se ha cambiado la fecha y la dirección de entrega.',
    CHANGE_DATE_AUTOMATIC_COLLECT: 'Se ha cambiado la fecha de recogida.',
    CHANGE_DATE_AUTOMATIC_DELIVERY: 'Se ha cambiado la fecha de entrega.',
    CHANGE_DAY: 'Cambiar el día',
    CHANGE_DELIVERY: 'Cambiar entrega',
    CHAT_TITLE: 'Mensajes',
    CITY: 'Ciudad',
    CLIENT_REQUEST_TYPE: 'Tipo de solicitud',
    CONFIRM_DELETE_MESSAGE: '¿Confirmas que quieres eliminar este mensaje?',
    CURRENT_COORDINATES: 'Coordenadas actuales',
    CUSTOMER_SUPPORT: 'atención al cliente',
    DATE: 'Fecha',
    DELETE_MESSAGE_NOW_ERROR:
      'No se puede eliminar el mensaje porque NOW ya lo ha leído.',
    DELETED_MESSAGE: 'Este mensaje se ha eliminado.',
    DELIVERY_HISTORY: 'Historial',
    DETAIL: 'Detalles',
    DOOR_NUMBER: 'Número',
    FILL_SEARCH_FIELDS:
      'Completa los campos: calle, número, código postal y ciudad.',
    FROM: 'De:',
    HOUR: 'Hora',
    INVALID_TRACKING: 'Número de seguimiento no válido',
    LOCATION_PREFERENCE: 'Preferencia de ubicación',
    MANDATORY_FIELD: 'Campo obligatorio.',
    MAX_CHARACTERS: 'Máximo de {max} caracteres.',
    MESSAGE: 'Mensaje',
    MESSAGES: 'Mensajes',
    NEW_MESSAGE: 'Nuevo mensaje',
    OBSERVATIONS: 'Observaciones',
    REQUEST_APROVED: 'Solicitud aceptada',
    REQUEST_CANCEL_TITLE: 'Cancelar solicitud',
    REQUEST_CHANGE_ADDRESS: 'Solicitud de cambio de dirección',
    REQUEST_CHANGE_DATE: 'Solicitud de cambio de fecha',
    REQUEST_CHANGE_DATE_AND_ADDRESS: 'Solicitud de cambio de fecha y dirección',
    REQUEST_CONTACT: 'Solicitud de contacto',
    REQUEST_CONTACT_TITLE: 'Solicitar contacto',
    REQUEST_MESSAGE: 'Solicitud de mensaje',
    REQUEST_REJECTED: 'Solicitud rechazada',
    SEARCH_ADDRESS: 'Buscar dirección',
    SEND_MESSAGE: 'Nuevo mensaje',
    STATUS: 'Estado',
    STATUS_CANCELED: 'Cancelado',
    STATUS_PENDING_TREATMENT: 'Pendiente',
    STATUS_REJECTED: 'Rechazado',
    STATUS_TREATED: 'Aprobado',
    STREET: 'Calle',
    TO: 'Para:',
    TYPE_MESSAGE: 'Escribe tu mensaje...',
    ZIP_CODE: 'Código postal'
  },
  SENTENCES: {
    ADDRESS_NOT_FOUND:
      'No se ha encontrado ninguna dirección 😞, inténtalo de nuevo.',
    CONFIRM_CHANGE:
      'Tu solicitud se ha enviado correctamente. Analizaremos la mejor forma de ayudarte 🙂.',
    CONFIRM_CHANGE_AUTOMATIC: 'Se ha aceptado tu solicitud 🙂.',
    CONFIRM_ERROR: 'Se ha producido un error, inténtalo de nuevo más tarde.',
    COORDINATES_NOT_FOUND:
      'No se han encontrado coordenadas para la dirección indicada.',
    DELIVERY_REQUEST_FAIL: '¡Error al cancelar la solicitud!',
    INVALID_DESTINATION: '¡Dirección de destino no válida!',
    MAXIMUM_CONTACT_REQUESTS:
      'Puedes hacer un máximo de {total} solicitudes de contacto.',
    MAXIMUM_REACHED: '¡Se ha alcanzado el número máximo de solicitudes!',
    MAXIMUM_REQUESTS:
      'Puedes hacer un máximo de {total} solicitudes de cambios.',
    MAXIMUM_REQUESTS_LEFT: 'Quedan {left}.',
    NOT_FOUND: 'Lo sentimos, no hemos encontrado lo que buscas.',
    NUMBER_OF_PACKAGES: '(compuesta por {total} cajas)',
    OUT_OF_RANGE:
      'La dirección a la que intentas cambiar está fuera del alcance del NOW. Para realizar este cambio, ponte en contacto con nuestro {support}.',
    PICK_UP_NOT_FOUND:
      'No se ha podido encontrar un punto de recogida 😞. Inténtalo de nuevo.',
    REQUEST_CANCEL_DESCRIPTION:
      '¿Confirmas que quieres cancelar la orden de cambio?',
    REQUEST_CHANGE_APPROVED: 'Se ha aceptado tu {type}.',
    REQUEST_CHANGE_REJECTED: 'No se ha aceptado tu {type}.',
    REQUEST_CONTACT_APPROVED: 'Contestaremos a tu {type}.',
    REQUEST_CONTACT_DESCRIPTION:
      'Una vez confirmado, nos pondremos en contacto contigo lo antes posible 🙂.',
    REQUEST_CONTACT_EVALUATION:
      'Ya hemos recibido una solicitud de contacto. Pronto nos pondremos en contacto contigo. Gracias.',
    REQUEST_CONTACT_REJECTED: 'No será posible contestar a su {type}.',
    REQUEST_CONTACT_SUBMITTED:
      'Tu solicitud se ha enviado correctamente. Alguien de PROZIS NOW se pondrá en contacto contigo lo antes posible 🙂.',
    SHOW_COLLECT_QR_CODE:
      'Muestra este código en el punto de recogida para que puedas entregar lo que quieras.',
    SHOW_DELIVERY_QR_CODE:
      'Muestra este código en el punto de recogida para recoger tu pedido.',
    STATUS_COLLECT_FAKE_PROCESSING:
      'La recogida se procesará hasta el {date}. Gracias 😉.',
    STATUS_COLLECT_IN_INTERRUPTED_ROUTE:
      'la ruta está actualmente interrumpida debido a problemas técnicos, tu solicitud se reanudará tan pronto como sea posible.',
    STATUS_COLLECT_IN_ROUTING:
      'Ya estamos en camino y la recogida la realizará {driver} entre las {from} y las {to}. Ya falta poco 😉.',
    STATUS_COLLECT_IN_SERVICE_POINT:
      'Estamos esperando a que indiques qué quieres que recojamos en {name}.',
    STATUS_COLLECT_ON_THE_WAY_TO_SERVICE_POINT:
      'Ya estamos en camino y la recogida la realizará {driver} entre las {from} y las {to} en el punto de recogida. Ya falta poco 😉.',
    STATUS_COLLECT_PROCESSING:
      'Tu pedido de recogida ya se procesó el {date} a las {hour}. Ya casi está 😉.',
    STATUS_COLLECT_SUCCESS:
      '{driver} recogió tu pedido el {date} a las {hour}. Si algo no ha ido bien, {support}.',
    STATUS_COLLECT_UNSUCCESS: '{driver} no ha podido recoger tu pedido.',
    STATUS_COLLECTED_SERVICE_POINT:
      'Tu pedido se ha recogido en {pickUp} el {date} a las {hour}.',
    STATUS_DELIVERED_SERVICE_POINT:
      'Tu pedido {packages} se ha recogido en el punto de recogida {pickUp} el {date} a las {hour}.',
    STATUS_DELIVERY_FAKE_PROCESSING:
      'tu pedido se procesará hasta el {date}. Gracias 😉.',
    STATUS_DELIVERY_IN_INTERRUPTED_ROUTE:
      'la ruta está actualmente interrumpida debido a problemas técnicos, tu solicitud se reanudará tan pronto como sea posible.',
    STATUS_DELIVERY_IN_ROUTING:
      'tu pedido {packages} ya está en camino y lo entregará {driver} entre las {from} y las {to}. Ya falta poco 😉.',
    STATUS_DELIVERY_IN_SERVICE_POINT:
      'Tu pedido {packages} está listo para ser recogido en el punto de recogida {name}.',
    STATUS_DELIVERY_IN_SERVICE_POINT_UNTIL:
      'Tienes hasta el día {date} para recoger tu pedido {packages}.',
    STATUS_DELIVERY_ON_THE_WAY_TO_SERVICE_POINT:
      'Tu pedido {packages} ya está en camino y lo entregará {driver} entre las {from} y las {to} en el punto de recogida {name}. Ya falta poco 😉.',
    STATUS_DELIVERY_PROCESSING:
      'Tu pedido {packages} fue procesado el día {date} a las {hour} y se encuentra en el centro de distribución: {location}. Ya falta poco 😉.',
    STATUS_DELIVERY_SUCCESS:
      '{driver} entregó tu pedido {packages} el día {date} a las {hour}. Si algo no está bien, {support}.',
    STATUS_DELIVERY_UNSUCCESS: '{driver} no ha podido entregar el pedido.',
    STATUS_HELLO: '👋 Hola, {name}:',
    UPDATING_CHANGE: 'Estamos actualizando tu solicitud 🙂',
    WARNING_DELIVERY_DELAY:
      'Aviso: hay un retraso en la entrega. Para obtener más información, ponte en contacto con {support}.',
    WARNING_REDUCED_EXPIRATION_DATE:
      'Atención: este pedido contiene uno o más artículos con un período de caducidad reducido que caducan el {date}. ¿Deseas continuar?'
  }
};
